export const appointmentStatusColorMapping = (theme) => ({
    pending: theme.palette.warning,
    upcoming: theme.palette.warning,
    cancelled: theme.palette.error,
    arrived: theme.palette.success,
    completed: theme.palette.success,
    no_show: theme.palette.error,
    incoming: theme.palette.warning,
});

export const consultStatusColorMapping = (theme) => ({
    not_started: theme.palette.error,
    in_progress: theme.palette.warning,
    completed: theme.palette.success,
    expired: theme.palette.error,
    procedures_completed: theme.palette.error,
    awaiting_omp: theme.palette.error,
});

export const uploadStatusMapping = (theme) => ({
    fail: theme.palette.error,
    success: theme.palette.success,
});

export const uploadSummaryMapping = (theme) => ({
    additions: theme.palette.success,
    removals: theme.palette.error,
    updates: theme.palette.info,
});

export const procedureIconMapping = {
    medical_history: 'medical_services',
    family_history: 'family_restroom',
    urine_analysis: 'science',
    physical_examination: 'accessibility',
    fatigue_management: 'favorite',
    eye_test: 'visibility',
};

export const procedureStatusColorMapping = (theme) => ({
    pending: theme.palette.warning,
    completed: theme.palette.success,
});

export const consultSummaryTypes = ['incapacity_disability']

export const consultTypeMapping = {
    occupational_health_consult_with_cof: 'Occupational Health Consult with COF',
    adhoc_occupational_health_consult_without_cof: 'Adhoc Occupational Health Consult without COF',
    primary_health_care_consult: 'Primary Health Care Consult',
    injury_on_duty_consult: 'Injury on Duty Consult',
    chronic_care_consult: 'Chronic Care Consult',
    workplace_disease_consult: 'Workplace Disease Consult',
    traveler_medical_consult: 'Traveler Medical Consult',
    care_review_consult: 'Care Review Consult',
    sick_note_submission: 'Sick Note Submission',
    incapacity_disability: "Incapacity/Disability Consult",
    "wellbeing_check-in": "Wellbeing Check-in",
    executive_health_assessment: "Executive Health Assessment",
};
